<template>
  <div class="coderpix_tm_section" id="portfolio">
    <div class="section_inner">
      <div class="coderpix_tm_portfolio swiper-section">
        <div class="coderpix_tm_main_title">
          <h3>Bazı <span class="coloring">Çalışmalar</span></h3>
        </div>
        <div class="portfolio_list gallery_zoom">
          <swiper
            :loop="false"
            :slidesPerView="1"
            :spaceBetween="0"
            :loopAdditionalSlides="1"
            :autoplay="{
              delay: 6000,
            }"
            :navigation="{
              nextEl: '.my_next',
              prevEl: '.my_prev',
            }"
            :pagination="pagination"
            :breakpoints="{
              700: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }"
            @slideChange="onSlideChange"
            :modules="modules"
            class="swiper-container"
          >
            <swiper-slide class="swiper-slide" v-for="(item, i) in portfolioList" :key="i">
              <div class="list_inner">
                <div class="image">
                  <img src="img/thumbs/1-1.jpg" alt="" />
                  <div class="main" :data-img-url="item.thumbnail" :style="{ backgroundImage: 'url(' + item.thumbnail + ')' }"></div>
                </div>
                <div class="details">
                  <h3>{{ item.title }}</h3>
                  <span>{{ item.category }}</span>
                </div>
                
                <!-- Popup Link logic based on type -->
                <a v-if="item.type === 'youtube'" class="coderpix_tm_full_link popup-youtube" :href="item.videoUrl || '#'"></a>
                <a v-else-if="item.type === 'vimeo'" class="coderpix_tm_full_link popup-vimeo" :href="item.videoUrl || '#'"></a>
                <a v-else-if="item.type === 'soundcloud'" class="coderpix_tm_full_link soundcloude_link mfp-iframe audio" :href="item.videoUrl || '#'"></a>
                <a v-else-if="item.type === 'image'" class="coderpix_tm_full_link zoom" :href="item.thumbnail"></a>
                <a v-else class="coderpix_tm_full_link portfolio_popup" href="#"></a>

                <!-- Popup Content (Only if type is popup) -->
                <div class="coderpix_tm_hidden_content" v-if="item.type === 'popup'">
                  <div class="portfolio_popup_details">
                    <div class="top_image">
                      <img src="img/thumbs/4-2.jpg" alt="" />
                      <div class="main" :data-img-url="item.popupImage || item.thumbnail" :style="{ backgroundImage: 'url(' + (item.popupImage || item.thumbnail) + ')' }"></div>
                    </div>
                    <div class="details">
                      <h3>{{ item.title }}</h3>
                      <span>{{ item.category }}</span>
                    </div>
                    <div class="text">
                      <p>{{ item.description }}</p>
                      <div class="additional_info" v-if="item.client || item.projectLink">
                          <p v-if="item.client"><strong>Müşteri:</strong> {{ item.client }}</p>
                          <p v-if="item.projectLink"><strong>Link:</strong> <a :href="item.projectLink" target="_blank">{{ item.projectLink }}</a></p>
                      </div>
                    </div>
                    <div class="additional_images" v-if="item.gallery && item.gallery.length > 0">
                      <ul class="gallery_zoom">
                        <li v-for="(img, idx) in item.gallery" :key="idx">
                          <div class="list_inner">
                            <div class="image">
                              <img src="img/thumbs/4-2.jpg" alt="" />
                              <div class="main" :data-img-url="img" :style="{ backgroundImage: 'url(' + img + ')' }"></div>
                              <a class="coderpix_tm_full_link zoom" :href="img"></a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- /Popup Content -->
              </div>
            </swiper-slide>

            <div class="coderpix_tm_swiper_progress fill">
              <div class="my_pagination_in">
                <span class="current">0</span>
                <span class="pagination_progress"
                  ><span class="all"
                    ><span
                      style="
                        transform: translate3d(0px, 0px, 0px) scaleX(0.75)
                          scaleY(1);
                      "
                    ></span></span
                ></span>
                <span class="total">04</span>
              </div>
              <div class="my_navigation">
                <ul>
                  <li>
                    <a class="my_prev" href="#"
                      ><i class="icon-left-open-1"></i
                    ></a>
                  </li>
                  <li>
                    <a class="my_next" href="#"
                      ><i class="icon-right-open-1"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Swiper core and required modules

// Import Swiper Vue.js components
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import { swiperSliderCustomSlider } from "../utilits";
import sanityClient, { urlFor } from "../sanity";

export default {
  name: `PortfolioComponent`,
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      portfolioList: [],
    };
  },
  methods: {
    onSlideChange(swiper) {
      this.activeSlider = swiper.activeIndex + 1;
    },
    imageUrl(source) {
      return source ? urlFor(source).url() : "img/thumb/1-1.jpg";
    },
    async fetchPortfolio() {
      try {
        const query = `*[_type == "portfolio"] | order(publishedAt desc) {
          title,
          category,
          type,
          videoUrl,
          "thumbnail": thumbnail.asset->url,
          "popupImage": popupImage.asset->url,
          description,
          client,
          projectLink,
          "gallery": gallery[].asset->url
        }`;
        const result = await sanityClient.fetch(query);
        if (result) {
          this.portfolioList = result;
        }
      } catch (error) {
        console.error("Portfolio fetch error:", error);
      }
    }
  },
  mounted() {
    this.fetchPortfolio();
  },
  setup() {
    return {
      modules: [Navigation, Pagination],
      pagination: {
        el: ".coderpix_tm_swiper_progress",
        type: "custom", // progressbar
        renderCustom: function (swiper, current, total) {
          swiperSliderCustomSlider(current, total);
        },
      },
    };
  },
};
</script>


